import React, { Component } from 'react';
import _ from 'lodash';
import viewHelper from '../../helpers/view';

import '../../assets/styles/book-appointment.css';
export default class SelectTrainer extends Component {

    render () {
        let trainers = this.props.trainers;
        return (
            <div className='select-activity'>
                <h3 className='col-xs-12 col-md-12 col-lg-12'>Select Staff</h3>
                {
                    _.map(trainers, (trainer) => {
                        return (
                            <div className="col-sm-6 col-xs-12 col-md-6" key={trainer.id}>
                                <div className='info-box'>
                                    <div className='info-box-header'>{viewHelper.getFullName(trainer)}</div>
                                    <button className='btn btn-primary' onClick={this.setTrainer.bind(this, trainer.id)}>Book With {trainer.first_name}</button>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        );
    }

    setTrainer (trainerId) {
        let newState = {activity: this.props.activity};
        newState.trainer = _.find(this.props.trainers, (trainer) => trainer.id === trainerId);
        this.props.callbackToUpdateComponent(newState);
    }
}
